import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { uploadFile } from '../request';
import { getBase64, isImage, isVideo, isPDF, isExcel, isWord } from '@/views/claim/demageManage/utils';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { cryptoDecrypt } from '@/utils/aes';
const MAX_SIZE = 50; // MB
const MAX_VIDEO_SIZE = 300; // MB
export default {
  props: {
    // item: {
    //   type: Object,
    //   default: () => {}
    // },
    // index: {
    //   type: Number,
    //   default: 0
    // },
    formDataArray: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    previewModal // 声明组件
  },
  data() {
    return {
      action: uploadFile,
      datalist: [],
      //存储获取的文件数据
      dataurls: [],
      //存储url地址
      isUploadDisabled: true,
      // 初始化上传按钮禁用状态

      isModalVisible: false,
      //
      uploadAccept: '',
      checkAll: false,
      indeterminate: false,
      fileDialog: false,
      previewVisible: false,
      previewSrc: '',
      previewXLSX: '',
      previewPDF: '',
      previewDocx: '',
      isPDFShow: false,
      isShow: '',
      currentPreviewIndex: 0,
      loading: false
    };
  },
  computed: {},
  created() {
    this.formDataArray.fileFormat = this.formDataArray.fileFormat.map(item => {
      return item.toLowerCase();
    });
    // console.log('获取文件格式---', this.formDataArray.fileFormat);
    console.log('获取文件url---', this.formDataArray.templateUrl);
    // if (!this.formDataArray.templateUrl.length) {
    //   this.formDataArray.templateUrl = this.formData[this.formDataArray.mark] || [];
    // }
  },
  methods: {
    // 模板预览打开
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      // console.log(data, '设置上传文件限制格式');
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    changeUploadTwo({
      file,
      fileList
    }) {
      if (file.status === 'uploading') {
        this.loading = true;
        console.log('---------loading-----------', this.loading);
      }
      const isVideoFile = isVideo(file.name);
      const maxSize = isVideoFile ? MAX_VIDEO_SIZE : MAX_SIZE;
      if (!this.isFileSizeValid(file, maxSize)) {
        const errorMessage = this.$t(isVideoFile ? '视频最大不超300M' : '文件最大不超50M');
        this.$message.error(errorMessage);
        return;
      }
      const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1).toLowerCase();
      // const fileType = file.type.split('/').pop().toLowerCase();
      // const fileType = file.name.substring(file.name.lastIndexOf('.'));
      // console.log('获取文件格式---eeee--顶顶顶顶-', fileType);
      // console.log('获取文件格式---获取子组件的文件类型---', this.formDataArray.fileFormat);
      // 文件类型
      if (!this.formDataArray.fileFormat.includes(fileType)) {
        this.$message.error(this.$t('文件格式错误'));
        return false;
      }

      // 文件列表
      this.datalist = fileList.map(item => {
        if (item.response && item.response.code === 200 && item.status === 'done') {
          this.loading = false;
          console.log('---------doneloading-----------', this.loading);
          item.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(item.response.data).fileTempUrl : item.response.data.fileTempUrl;
          // 将文件URL添加到templateUrl变量中
          // this.dataurls += item.url;
        }
        return item;
      });
      this.dataurls = this.datalist.map(item => {
        return {
          uid: item.uid,
          url: item.url,
          name: item.name,
          size: item.size
        };
      });
      this.$set(this.formData, this.formDataArray.mark, this.dataurls);
      // this.formData[this.formDataArray.mark] = this.datalist;
      // this.$emit('update:controlMark', this.dataurls);
    },
    // 附件上传新建
    // beforeUpload(file) {
    //   return new Promise((resolve, reject) => {
    //     const fileTypeAAA = file.name.substring(file.name.lastIndexOf('.')).substring(1);
    //     // 检查文件类型是否符合要求
    //     if (!this.formDataArray.fileFormat.includes(fileTypeAAA)) {
    //       this.$message.error(this.$t('文件格式错误'));
    //       reject(false); // 不允许文件上传
    //     } else {
    //       resolve(true); // 允许文件上传
    //     }
    //   });

    //   const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1);
    //   // "fileFormat": "文件格式：Word Xlsx xls JPG mov jpeg mp4 PDF BMP docx doc rm rmvb avi jpg
    //   const isValidType = this.formDataArray.fileFormat.includes(fileType);
    //   if (!isValidType) {
    //     this.$message.error(this.$t('文件格式错误'));
    //     return false;
    //   }
    //   const isValidSize =
    //     file.size / (this.formDataArray.fileSize.type === 'MB' ? 1024 * 1024 : 1024) < this.formDataArray.fileSize.size;
    //   if (!isValidSize) {
    //     this.$message.error(this.$t('文件大小超过限制'));
    //   }
    //   // return isValidType && isValidSize;
    //   // this.isUploadDisabled = false; // 符合条件时启用上传按钮
    //   return isValidType && isValidSize;
    // },
    // 附件上传新建
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1).toLowerCase();

        // 检查文件类型是否符合要求
        if (!this.formDataArray.fileFormat.includes(fileType)) {
          this.$message.error(this.$t('文件格式错误'));
          reject(false); // 不允许文件上传
        }
        const isValidSize = file.size / (this.formDataArray.fileSize.type === 'MB' ? 1024 * 1024 : 1024) < this.formDataArray.fileSize.size;

        // 检查文件大小是否超过限制
        if (!isValidSize) {
          this.$message.error(this.$t('文件大小超过限制'));
          reject(false); // 不允许文件上传
        }
        // if (!this.formData[this.formDataArray.mark]) {
        //   this.formData[this.formDataArray.mark] = [];
        // }
        // this.formData[this.formDataArray.mark].push(file);
        resolve(true); // 允许文件上传
      });
    },
    isFileSizeValid(file, maxSize) {
      let currentSize = file.size / 1024 / 1024;
      // console.log('file.size', maxSize, file, currentSize);
      return currentSize < maxSize;
    },
    async handlePreview(file) {
      this.isShow = '';
      let type = file.url.substring(file.url.lastIndexOf('.')).substring(1).toLowerCase();
      console.log(type, '--------type-------');
      if (isImage(type)) {
        this.isShow = 'image';
      }
      if (isVideo(type)) {
        this.isShow = 'video';
      }
      //
      if (isExcel(type)) {
        // this.isShow = 'xlsx';
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewXLSX = urlid + file.url;
        window.open(this.previewXLSX);
      }
      // doc格式打不开
      if (isWord(type)) {
        // this.isShow = 'xlsx';
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewDocx = urlid + file.url;
        window.open(this.previewDocx);
      }
      this.isPDFShow = isPDF(type);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      console.log(this.isShow, '-------');
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.formDataArray.templateUrl.indexOf(file);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    removeUploadFile(file) {
      const index = this.dataurls.indexOf(file);
      const newFileList = this.dataurls.slice();
      // console.log('newFileList type:', typeof newFileList); // 检查newFileList的类型
      // console.log('newFileList:', newFileList); // 输出newFileList的内容
      newFileList.splice(index, 1);
      this.dataurls = newFileList;
      this.$set(this.formData, this.formDataArray.mark, this.dataurls);
      // console.log('删除url地址', this.dataurls);
      // this.$emit('update:controlMark', this.dataurls);
    },
    cancelPre() {
      this.previewVisible = false;
      this.previewSrc = '';
    }
  }
};